import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

/**
 * The MARKETING admin role (2026-10-21): the « Marketing » and « Acquisition »
 * tabs only. David: « onglet : marketing & acquisition ».
 *
 * This is the dashboard half, and it is only ergonomics: it hides the other
 * tabs and sends a marketing admin who lands anywhere else back to Marketing.
 * The protection is the API's. The backend refuses a MARKETING token on every
 * route not opened with `@MarketingAccess()`, so a page this file forgot to
 * hide would load empty, not leak.
 */
export const MARKETING_ROLE = 'MARKETING';

/** Where a marketing admin lands, and is sent back to. */
export const MARKETING_HOME = paths.dashboard.marketing.root;

const MARKETING_PATHS = [paths.dashboard.marketing.root, paths.dashboard.acquisition.root];

export const isMarketingRole = (role?: string | null) => role === MARKETING_ROLE;

export const isPathOpenToMarketing = (pathname: string) =>
  MARKETING_PATHS.some((root) => pathname === root || pathname.startsWith(`${root}/`));

/** The sidebar a given role sees: everything, or for MARKETING its two tabs. */
export function navForRole(
  data: NavSectionProps['data'],
  role?: string | null
): NavSectionProps['data'] {
  if (!isMarketingRole(role)) return data;
  return data
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => isPathOpenToMarketing(item.path)),
    }))
    .filter((section) => section.items.length > 0);
}
